<nav class="navbar navbar-expand-sm fixed-top">
    <!-- Brand/logo -->
    <div class="navlogo">
      <img [src]="siteLogo">
    </div>
</nav>
<div class="password_container">
    <div [formGroup]="passwordForm" class="mt-4">
        <div class="main_header">
            <h1>Reset Password</h1>
        </div>
        <div>
            <mat-form-field class="name_input me-2" appearance="outline" floatLabel="always"
                [hideRequiredMarker]="false">
                <mat-label>New Password</mat-label>
                <input required style="height: auto;" matInput required [type]="hidePassword ? 'text' : 'password'"
                    placeholder="Enter new password" formControlName="password" [(ngModel)]="password"
                    (keyup)="validate()" formControlName="password" autocomplete="off"
                    matTooltip="Password should be between 8 to 20 characters long, with atleast 1 uppercase
                    letter, atleast 1 lowercase letter, atleast 1 number, and atleast 1 special character(except (') and (“))" />
                <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword"
                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
                    <mat-icon>{{hidePassword ? 'visibility' : 'visibility_off'}}</mat-icon>
                </button>
                <mat-error *ngIf="passwordForm.hasError('minlength', 'password')">
                    Password should have 8 or more characters.
                </mat-error>
                <mat-error *ngIf="passwordForm.hasError('maxlength', 'password')">
                    Password should not have more than 20 characters.
                </mat-error>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="name_input me-2 mt-1" appearance="outline" floatLabel="always"
                [hideRequiredMarker]="false">
                <mat-label>Confirm New Password</mat-label>
                <input required style="height: auto;" matInput required [type]="hideCnfrmPassword ? 'text' : 'password'"
                    placeholder="Repeat new password" [(ngModel)]="cnfrmPassword" (keyup)="validate()"
                    formControlName="confirmPassword" [errorStateMatcher]="matcher" autocomplete="off" />
                <button mat-icon-button matSuffix (click)="hideCnfrmPassword = !hideCnfrmPassword"
                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideCnfrmPassword">
                    <mat-icon>{{hideCnfrmPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
                </button>
                <mat-error *ngIf="passwordForm.hasError('notSame')">
                    Reentered password does not match.
                </mat-error>
            </mat-form-field>
        </div>
        <div class="float-end">
          <img *ngIf="loading" style="margin:0 20px ;width: 20px; height: auto;"
          src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
            <button [disabled]="!isValid || loading" mat-button (click)="updatePasswordRequest()"
                [ngClass]="{'create-btn-disabled': !isValid, 'create-btn': true, 'mt-2': true}">
                Update
            </button>
        </div>
    </div>
</div>
